import React, { useState, useEffect } from 'react';
import Card from './Card';
import api from '../api';

function AllCards() {
  const [cards, setCards] = useState([]);
  const API = process.env.REACT_APP_API;

  useEffect(() => {

    async function fetchCards() {
      try {
        let apiEndpoint = API;

        // Get selected card set from localStorage, default to 'default'
        const selectedCardSet = localStorage.getItem('selectedCardSet') || 'default';
        const endpoint = `${apiEndpoint}/card/getCards?cardSet=${selectedCardSet}`;

        const response = api.get(endpoint);
        const data = await response;

        // Handle new response structure with backward compatibility
        const cardsArray = data.cards || data; // Support both old and new response formats
        const fallbackUsed = data.fallbackUsed || false;
        const cardSet = data.cardSet || 'default';

        // Log fallback usage for debugging
        if (fallbackUsed) {
          console.log(`⚠️ Using fallback card set '${cardSet}' in AllCards component`);
        }

        // Sort the cards by palette number
        const sortedCards = cardsArray.sort((a, b) => a.paletteNumber - b.paletteNumber);
        setCards(sortedCards);
      } catch (error) {
        console.error('Error fetching cards:', error);
      }
    }
    fetchCards();
  }, [API]);

  return (
    <div>
      {cards.map(card => (
        <Card key={card.paletteNumber} card={card} />
      ))}
    </div>
  );
}

export default AllCards;
